function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "current",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Comp-/-left-menu-Hospital",
  transform: "translate(-16.000000, -490.000000)",
  fill: "current",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: 9,
  transform: "translate(16.000000, 488.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.8727321,2.57875004 C16.8343891,3.37300897 18.4304633,4.8846181 19.3451758,6.8145099 C19.7929634,7.75704011 20.0197699,8.79171375 20.0078896,9.83775751 C20.0116737,11.2710426 19.765702,12.6937438 19.2813054,14.0403221 C18.3508193,16.5137016 17.1427051,18.8703821 15.680786,21.0638915 C14.5679897,22.7778432 13.3594144,24.4259024 12.0609772,26 C11.1950553,24.9186739 10.3351359,24.002438 9.65831934,22.9639941 L8.72814426,21.5415472 C7.9547489,20.3546503 7.1951877,19.1576966 6.52039417,17.9038464 C5.52395753,16.1305335 4.77465527,14.2258795 4.29384611,12.2441761 C3.49086606,9.36282803 4.36331204,6.26896352 6.54731765,4.2529242 C8.74199551,2.05676995 12.0170719,1.39817832 14.8727321,2.57875004 Z M12.1224,5.6488372 C11.0597329,5.62465505 10.0335506,6.04208521 9.2822173,6.80416595 C8.53088402,7.56624668 8.11979083,8.60665156 8.1444275,9.68371269 C8.12224795,10.739407 8.52591787,11.7585875 9.26213937,12.5056967 C9.99836087,13.2528059 11.0034151,13.6631828 12.0450096,13.6419792 C14.1940643,13.6183448 15.9368458,11.8704616 15.9828301,9.6926317 C15.9639619,7.5177334 14.2664125,5.73955305 12.1224,5.6488372 Z M13.0372007,8.03286862 C14.0927141,8.06654335 14.9433063,8.90870928 14.9869556,9.96330862 C14.9898552,10.4990378 14.7768838,11.0133847 14.3960549,11.390392 C14.0152261,11.7673993 13.4985978,11.9753306 12.9626418,11.9673086 C11.8928489,11.9615935 11.0272835,11.0957292 11.0224919,10.0264886 C11.0170742,9.49261245 11.2282563,8.97931069 11.6078641,8.60367648 C11.9874718,8.22804228 12.503125,8.0221144 13.0372007,8.03286862 Z",
  id: "Combined-Shape"
}))));

function SvgIconLeftmenuHospital09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_leftmenu_hospital09") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftmenuHospital09);
export default __webpack_public_path__ + "static/media/icon_leftmenu_hospital09.b8f77b63.svg";
export { ForwardRef as ReactComponent };